import { Colors } from '@amelio/ui-library';

import { Bone, Skeleton } from '@/components/Skeleton/Skeleton';

export const AddEditValueModalSkeleton = () => {
    return (
        <Skeleton className={'bg-white'}>
            {/* Header skeleton */}
            <div className={'mb-6'}>
                <Bone
                    color={Colors.BASE_200}
                    className={'mb-2 h-7 w-3/4'}
                />
                <Bone
                    color={Colors.BASE_200}
                    className={'h-4 w-1/2'}
                />
            </div>

            {/* Tab navigation skeleton */}
            <div className={'mb-6 flex gap-2 border-b-2 border-gray-200'}>
                {[0, 1, 2].map((index) => (
                    <Bone
                        key={index}
                        color={Colors.BASE_200}
                        className={'h-12 w-24'}
                    />
                ))}
            </div>

            {/* Content skeleton - matching details tab structure */}
            <div className={'flex flex-col gap-6'}>
                {/* Name input skeleton */}
                <div className={'flex flex-col gap-2'}>
                    <Bone
                        color={Colors.BASE_200}
                        className={'h-4 w-20'}
                    />
                    <Bone
                        color={Colors.BASE_200}
                        className={'h-10 w-full'}
                    />
                </div>

                {/* Description textarea skeleton */}
                <div className={'flex flex-col gap-2'}>
                    <Bone
                        color={Colors.BASE_200}
                        className={'h-4 w-24'}
                    />
                    <Bone
                        color={Colors.BASE_200}
                        className={'h-24 w-full'}
                    />
                </div>

                {/* Icon picker skeleton */}
                <div className={'flex flex-col gap-2'}>
                    <Bone
                        color={Colors.BASE_200}
                        className={'h-4 w-16'}
                    />
                    <div className={'grid grid-cols-8 gap-2'}>
                        {Array.from({ length: 16 }).map((_, index) => (
                            <Bone
                                key={index}
                                color={Colors.BASE_200}
                                className={'h-10 w-10'}
                            />
                        ))}
                    </div>
                </div>

                {/* Color picker skeleton */}
                <div className={'flex flex-col gap-2'}>
                    <Bone
                        color={Colors.BASE_200}
                        className={'h-4 w-20'}
                    />
                    <div className={'flex gap-2'}>
                        {Array.from({ length: 8 }).map((_, index) => (
                            <Bone
                                key={index}
                                color={Colors.BASE_200}
                                className={'h-10 w-10'}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </Skeleton>
    );
};
